import * as ExcelJSLib from "exceljs";

export const ExcelJS = ExcelJSLib;
